import { REQUEST_FETCH_X_CSRF_TOKEN } from 'actions/actionTypes';
import * as Action from 'actions/appActions';
import * as API from 'apis';
import { call, fork, put, take } from 'redux-saga/effects';

function* runRequestFetchXCSRFToken() {
  const { payload, error, newXCSRFToken } = yield call(API.requestFetchXCSRFToken);

  if (payload && !error) {
    yield put(Action.successFetchXCSRFToken(newXCSRFToken));
  } else {
    yield put(Action.failureFetchXCSRFToken());
  }
}

function* handleRequestFetchXCSRFToken() {
  while (true) {
    yield take(REQUEST_FETCH_X_CSRF_TOKEN);
    yield fork(runRequestFetchXCSRFToken);
  }
}

export default function* appSaga() {
  yield fork(handleRequestFetchXCSRFToken);
}
